import type { TFunction } from 'i18next'

/**
 * Category names are stored in Italian in PostgreSQL. The UI must render the
 * active app locale, so every category surface resolves the slug through this
 * catalog and only falls back to the API name for an unknown slug.
 */
export function localizedCategoryName(
  t: TFunction,
  slug: string | null | undefined,
  fallback: string,
): string {
  const key = slug?.trim()
  if (!key) return fallback
  return t(`categoryNames.${key}` as never, { defaultValue: fallback })
}
